import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, finalize} from 'rxjs';
import {OpenRequestsService} from '../services/open-requests.service';

@Injectable({
  providedIn: 'root'
})
export class OpenRequestsInterceptor implements HttpInterceptor {

  constructor(
    private requestCountService: OpenRequestsService
  ) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const id = this.requestCountService.generateId();
    console.info('RequestCountInterceptor pre');
    this.requestCountService.addRequest(id, req.url);
    return next.handle(req).pipe(
      finalize(() => {
        console.log('RequestCountInterceptor complete', id);
        this.requestCountService.setRequestDone(id);
      })
    );
  }
}
